import React, { useEffect, useState } from "react";
import { StyleSheet, ScrollView, SafeAreaView } from "react-native";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { loadSurvey } from "../../../services/SurveyService";
import { useTheme } from 'react-native-paper';

import CustomSurvey from "../../../components/SurveyBuilderComponent/Survey/CustomSurvey";

/** This page allows you to edit your survey. 
 *     -> The survey must not have any answers to make changes in the structure. 
 *     -> You should be allowed to change text of the questions (Not done yet)
 */

const EditSurvey = (props) => {

    // * Get ID of Survey to load 
    const survId = props.survId;
    const {clientApi} = useAuthContext(); 
    // TODO Change organization id when you want to support multiCple companies
    const [survey, setSurvey] = useState({})

    // * state array of section each section contains array of questions 
    const [sectionQuestionList, setSectionQuestionList] = useState([])
    const { colors } = useTheme()
    const styles = makeStyles(colors)
    
    // Load selectd Survey to the screen 
    useEffect(() => {
        // console.log("Use Effect Loaded for Edit Survey");
        // Get each section of the report after the previous call has responded.
        loadSurvey(clientApi, survId)
            .then(respSurvey => {
                console.log(respSurvey)
                setSurvey(respSurvey.sh)
                setSectionQuestionList(respSurvey.ss)

            }).catch(error => {
                console.log(error)
            });

    }, []);

    return (
        <SafeAreaView style={[styles.main]}>
            <ScrollView>
                <CustomSurvey
                    survey={survey}
                    setSurvey={setSurvey}
                    sectionQuestionList={sectionQuestionList}
                    setSectionQuestionList={setSectionQuestionList}
                    isEdit={1}
                    isCreate={1}
                    setShowResponseScreen={props.setShowResponseScreen}
                    setShowEditScreen={props.setShowEditScreen}
                    setShowMySurveys={props.setShowMySurveys}
                    setShowCreateScreen={props.setShowCreateScreen}
                    setShowSurveysAdmin={props.setShowSurveysAdmin}
                />
            </ScrollView>
        </SafeAreaView>
    );
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    }
})

export default EditSurvey; 